import { Component } from '@angular/core';

@Component({
  selector: 'mt-how-it-works-section',
  templateUrl: './how-it-works-section.component.html',
  styleUrls: ['./how-it-works-section.component.scss', '../home.component.scss'],
})
export class HowItWorksSectionComponent {}
